import km from "../media/logotypy/km.png";
import skm from "../media/logotypy/skm.png";
import Train from "../elements/icons/Train";

export class Operator {
    /** @type string */
    _timetable_source = "";
    /** @type Date */
    _data_from = undefined;
    /** @type Date */
    _data_to = undefined;
    /** @type Date */
    _feed_version = undefined;

    /**
     * Koleje Mazowieckie
     * @returns {Operator}
     * @constructor
     */
    static KM() {
        return new Operator("Koleje Mazowieckie", "KM", km, "#238132")
    }

    /**
     * SKM Warszawa
     * @returns {Operator}
     * @constructor
     */
    static SKM() {
        return new Operator("SKM Warszawa", "SKM", skm, "#cf2e2e")
    }

    /**
     * Zwraca obiekt operatora na podstawie nazwy (skrótu)
     * @param {string} name
     * @returns {Operator}
     */
    static getByName(name) {
        switch (name) {
            case 'km':
                return Operator.KM()
            case 'skm':
                return Operator.SKM()
            case 'wtp':
                return Operator.SKM()
            default:
                return null;
        }
    }

    /**
     * Logotyp przewoźnika
     * @returns
     */
    get logo() {
        return this._logo;
    }

    /**
     * Nazwa przewoźnika
     * @returns {string}
     */
    get nazwa() {
        return this._nazwa
    }

    /**
     * Nazwa przewoźnika do spisu taboru
     * @returns {JSX.Element}
     */
    get nazwa_spisTaboru() {
        return <span style={{color: this.color}}><Train/>&nbsp;{this.nazwa}</span>
    }

    /**
     * Skrót nazwy przewoźnika
     * @returns {string}
     */
    get short() {
        return this._short;
    }

    /**
     * Kolor dla elementów systemu związanych z przewoźnikiem
     * @returns {string}
     */
    get color() {
        return this._color;
    }

    /**
     * Aktualizuje informacje o wersji rozkładu jazdy
     * @param {string} timetable_source Źródło danych rozkładowych
     * @param {string} data_from Zakres ważności rozkładów jazdy (od)
     * @param {string} data_to Zakres ważności rozkładów jazdy (do)
     * @param {Date} feed_version Data i godzina aktualizacji pliku GTFS
     */
    updateTimetableInfo(timetable_source, data_from, data_to, feed_version) {
        this._timetable_source = timetable_source;
        this._data_from = new Date(data_from);
        this._data_to = new Date(data_to);
        this._feed_version = new Date(feed_version);
    }

    /**
     * Źródło danych rozkładowych
     * @return {string}
     */
    get timetable_source() {
        return this._timetable_source;
    }

    /**
     * Zakres ważności rozkładów jazdy (od)
     * @returns {Date}
     */
    get data_from() {
        return this._data_from;
    }

    /**
     * Zakres ważności rozkładów jazdy (do)
     * @returns {Date}
     */
    get data_to() {
        return this._data_to;
    }

    /**
     * Data i godzina aktualizacji pliku GTFS
     * @returns {Date}
     */
    get feed_version() {
        return this._feed_version;
    }

    /**
     *
     * @param {string} nazwa
     * @param {string} short
     * @param {string} logo
     * @param {string} color
     * @private
     */
    constructor(nazwa, short, logo, color) {
        this._nazwa = nazwa;
        this._short = short;
        this._logo = logo;
        this._color = color;
    }

}
